import { render, staticRenderFns } from "./VideoTags.vue?vue&type=template&id=e2634782&"
import script from "./VideoTags.vue?vue&type=script&lang=js&"
export * from "./VideoTags.vue?vue&type=script&lang=js&"
import style0 from "./VideoTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports